import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import { AuthProvider } from "./context/AuthContext"
import { LangProvider } from "./context/LangContext"

/* Public pages */
import HomePage from "./pages/HomePage"
import AboutPage from "./pages/AboutPage"
import AlliancesPage from "./pages/AlliancesPage"
import CompoundInterestCalculator from "./pages/CompoundInterestCalculator"
import CoinMarketTrackerPage from "./pages/CoinMarketTrackerPage"
import EconomicCalendarPage from "./pages/EconomicCalendarPage"
import PricingPage from "./pages/PricingPage"
import FAQsPage from "./pages/FAQsPage"
import ContactPage from "./pages/ContactPage"

/* Legal */
import PrivacyPage from "./pages/PrivacyPage"
import TermsPage from "./pages/TermsPage"
import IntellectualPropertyPage from "./pages/IntellectualPropertyPage"

/* Auth */
import LoginPage from "./pages/LoginPage"
import RegisterPage from "./pages/RegisterPage"

/* Private pages */
import DashboardPage from "./pages/DashboardPage"
import TimeTracker from "./pages/TimeTracker"

/* Layouts */
import AppLayout from "./layouts/AppLayout"
import PublicLayout from "./layouts/PublicLayout"
import ProtectedRoute from "./components/ProtectedRoute"
import RequirePlan from "./components/RequirePlan"

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* PUBLIC */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/alliances" element={<AlliancesPage />} />
              <Route path="/compound-interest" element={<CompoundInterestCalculator />} />
              <Route path="/coin-market-tracker" element={<CoinMarketTrackerPage />} />
              <Route path="/economic-calendar" element={<EconomicCalendarPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/faqs" element={<FAQsPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Legal */}
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/intellectual-property" element={<IntellectualPropertyPage />} />

              {/* Auth */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
            </Route>

            {/* PRIVATE /app/* */}
            <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="time-tracker" element={<RequirePlan plans={["plus","basic","premium"]}><TimeTracker /></RequirePlan>} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LangProvider>
  )
}
